export default "__VITE_PUBLIC_ASSET__87136fc7__"